import React from 'react';
import { Box, Container, Typography, keyframes } from '@mui/material';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const ComingSoonPage = () => {
  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '80vh',
          textAlign: 'center',
          animation: `${fadeIn} 1.5s ease-in-out`,
        }}
      >
        <Typography 
          variant="h2" 
          component="h1" 
          gutterBottom
          sx={{
            fontFamily: 'Oswald, sans-serif',
            fontWeight: 700,
          }}
        >
          Coming Soon
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Our new website is under construction but we are excited to share it with you soon.
        </Typography>
      </Box>
    </Container>
  );
};

export default ComingSoonPage;
